import { LowTonnageReason } from "@/pages/caster/models/catalogs/low-tonnage-reasons";
import { MESApiService } from "@dexteel/mesf-core";

export const getCatalogLowTonnageReasons = async () => {
	const apiService = new MESApiService();
	return await apiService.callV2("[CAS].[GetCatalogLowTonnageReasons]", []);
};

export const upsertLowTonnageReason = async (data: LowTonnageReason) => {
	const apiService = new MESApiService();
	return await apiService.callV2("[CAS].[UpsertLowTonnageReason]", [
		{ name: "LowTonnageReasonId", value: data.LowTonnageReasonId || null },
		{ name: "LowTonnageReasonName", value: data.LowTonnageReasonName },
		{ name: "IsActive", value: data.IsActive },
	]);
};

export const deleteLowTonnageReason = async (lowTonnageReasonId: number) => {
	const apiService = new MESApiService();
	return await apiService.callV2("[CAS].[DeleteLowTonnageReason]", [
		{ name: "LowTonnageReasonId", value: lowTonnageReasonId },
	]);
};
